import { render } from "./Study.vue?vue&type=template&id=4b8aa126&scoped=true"
import script from "./Study.vue?vue&type=script&lang=js"
export * from "./Study.vue?vue&type=script&lang=js"

import "./Study.vue?vue&type=style&index=0&id=4b8aa126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8aa126"]])

export default __exports__